import React from 'react';
import { motion } from 'framer-motion';
import { useData } from '../../config/DataContext';

const Counters = () => {
  const { projects } = useData();

  const counterData = [
    {
      id: 1,
      icon: "🚀",
      count: projects.length,
      label: "Projects Completed",
      caption: "Delivered with excellence"
    },
    {
      id: 2,
      icon: "🤝",
      count: 9,
      label: "Happy Clients",
      caption: "Satisfied worldwide"
    }
  ];

  return (
    <section className="w-full py-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {counterData.map((item) => (
          <motion.div
            key={item.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: item.id * 0.1 }}
            className="w-full p-5 rounded-xl border border-white/10 bg-white/5 backdrop-blur-md group hover:border-cyan-500/30 hover:bg-cyan-500/5 transition-all duration-500 relative overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-blue-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <div className="relative z-10 flex items-center gap-4">
              <span className="text-3xl group-hover:scale-110 transition-transform duration-300">
                {item.icon}
              </span>
              <div>
                <h3 className="text-3xl font-bold text-white group-hover:text-cyan-400 transition-colors duration-300 font-titleFont">
                  {item.count}
                </h3>
                <h4 className="text-sm font-titleFont font-semibold text-gray-300">
                  {item.label}
                </h4>
                <p className="text-xs text-gray-500 group-hover:text-gray-400 transition-colors duration-300">
                  {item.caption}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Counters;
